import api from './api';

const purchasesService = {
  // Listar compras
  getAllPurchases: async (params = {}) => {
    const queryParams = new URLSearchParams();

    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });

    const response = await api.get(`/purchases?${queryParams.toString()}`);
    return response.data;
  },

  // Obter compra por ID
  getPurchaseById: async (id) => {
    const response = await api.get(`/purchases/${id}`);
    return response.data;
  },

  // Criar compra
  createPurchase: async (purchaseData) => {
    const response = await api.post('/purchases', purchaseData);
    return response.data;
  },

  // Atualizar compra
  updatePurchase: async (id, purchaseData) => {
    const response = await api.put(`/purchases/${id}`, purchaseData);
    return response.data;
  },

  // Confirmar compra (mover para estoque)
  confirmPurchase: async (id, confirmData) => {
    const response = await api.post(`/purchases/${id}/confirm`, confirmData);
    return response.data;
  },

  // Pagar compra (gera despesa no caixa)
  payPurchase: async (id, payData) => {
    const response = await api.post(`/purchases/${id}/pay`, payData);
    return response.data;
  },

  // Cancelar compra
  cancelPurchase: async (id) => {
    const response = await api.post(`/purchases/${id}/cancel`);
    return response.data;
  },

  // Excluir compra (apenas DRAFT)
  deletePurchase: async (id) => {
    const response = await api.delete(`/purchases/${id}`);
    return response.data;
  },

  // Buscar variantes para autocomplete
  searchVariants: async (query, supplierId = null) => {
    const params = new URLSearchParams();
    params.append('q', query);
    if (supplierId) {
      params.append('supplier_id', supplierId);
    }
    const response = await api.get(`/purchases/search-variants?${params.toString()}`);
    return response.data;
  },

  // Listar anexos da compra
  getPurchaseFiles: async (purchaseId) => {
    try {
      const response = await api.get(`/purchases/${purchaseId}/files`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar anexos da compra:', error);
      throw error;
    }
  },

  // Upload de anexos da compra
  uploadPurchaseFiles: async (purchaseId, files) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file);
      });
      const response = await api.post(`/purchases/${purchaseId}/files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar anexos da compra:', error);
      throw error;
    }
  },

  // Excluir anexo da compra
  deletePurchaseFile: async (fileId) => {
    try {
      const response = await api.delete(`/purchases/files/${fileId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir anexo da compra:', error);
      throw error;
    }
  }
};

export default purchasesService;
